/* eslint-disable max-len */
import styled from 'styled-components'
import { number, string } from 'prop-types'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const Svg = styled.svg`
  cursor: pointer;
  flex: 0 0 24px;
  margin-top: 2px;
  margin-left: 2px;
  .a {
    fill: ${prop('color', colorsOptions.greys['grey-50'])};
  }
  &:hover {
    .a {
      fill: ${prop('hoverColor', colorsOptions.secondaryColors.petrol.strong)};
    }
  }
`
function PlaceholderIcon({ color, hoverColor, size, ...props }) {
  return (
    <Svg
      viewBox="0 0 19 19"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
    >
      <path
        className="a"
        id="Pfad_12917"
        d="M313.723,169.185a.764.764,0,0,1,.761-.761c.741,0,1.176-.181,1.176-1.121,0-1.2-.29-2.3-.29-3.657,0-1.2.815-2.461,2.824-2.461a.887.887,0,0,1,0,1.773.773.773,0,0,0-.851.851c0,1.121.163,2.009.163,2.969,0,1.322-.344,2.027-1.284,2.407.94.38,1.284,1.087,1.284,2.407,0,.96-.163,1.847-.163,2.969a.773.773,0,0,0,.851.851.887.887,0,0,1,0,1.773c-2.009,0-2.824-1.266-2.824-2.461,0-1.358.29-2.461.29-3.657,0-.94-.435-1.121-1.176-1.121A.764.764,0,0,1,313.723,169.185Z"
        transform="translate(-313.723 -161.185)"
      />
      <path
        className="a"
        id="Pfad_12918"
        d="M317.5,169.185a.764.764,0,0,1,.761-.761c.741,0,1.176-.181,1.176-1.121,0-1.2-.288-2.3-.288-3.657,0-1.2.813-2.461,2.822-2.461a.887.887,0,1,1,0,1.773.773.773,0,0,0-.851.851c0,1.121.164,2.009.164,2.969,0,1.322-.346,2.027-1.286,2.407.94.38,1.286,1.087,1.286,2.407,0,.96-.164,1.847-.164,2.969a.773.773,0,0,0,.851.851.887.887,0,1,1,0,1.773c-2.009,0-2.822-1.266-2.822-2.461,0-1.358.288-2.461.288-3.657,0-.94-.435-1.121-1.176-1.121A.764.764,0,0,1,317.5,169.185Z"
        transform="translate(-311.798 -161.185)"
      />
      <path
        className="a"
        id="Pfad_12920"
        d="M330.433,169.185a.766.766,0,0,1-.761.761c-.742,0-1.176.181-1.176,1.121,0,1.2.288,2.3.288,3.657,0,1.2-.815,2.461-2.824,2.461a.887.887,0,1,1,0-1.773.773.773,0,0,0,.851-.851c0-1.121-.163-2.009-.163-2.969,0-1.32.344-2.027,1.286-2.407-.942-.38-1.286-1.085-1.286-2.407,0-.96.163-1.847.163-2.969a.773.773,0,0,0-.851-.851.887.887,0,1,1,0-1.773c2.009,0,2.824,1.266,2.824,2.461,0,1.358-.288,2.461-.288,3.657,0,.94.433,1.121,1.176,1.121A.766.766,0,0,1,330.433,169.185Z"
        transform="translate(-310.944 -161.185)"
      />
      <path
        className="a"
        id="Pfad_12921"
        d="M334.211,169.185a.765.765,0,0,1-.761.761c-.743,0-1.176.181-1.176,1.121,0,1.2.288,2.3.288,3.657,0,1.2-.815,2.461-2.824,2.461a.887.887,0,0,1,0-1.773.773.773,0,0,0,.851-.851c0-1.121-.163-2.009-.163-2.969,0-1.32.344-2.027,1.286-2.407-.942-.38-1.286-1.085-1.286-2.407,0-.96.163-1.847.163-2.969a.773.773,0,0,0-.851-.851.887.887,0,0,1,0-1.773c2.009,0,2.824,1.266,2.824,2.461,0,1.358-.288,2.461-.288,3.657,0,.94.433,1.121,1.176,1.121A.765.765,0,0,1,334.211,169.185Z"
        transform="translate(-309.019 -161.185)"
      />
    </Svg>
  )
}

PlaceholderIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number,
}

export default PlaceholderIcon
